var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isPopinDisplayed,
          expression: "isPopinDisplayed",
        },
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: { callback: _vm.popin_reservationDisplayed_callback },
          expression: "{ callback: popin_reservationDisplayed_callback }",
        },
      ],
      staticClass: "popin-modal from-sides right",
      class: { active: _vm.isPopinLoaded },
      attrs: { id: "reservation" },
    },
    [
      _c("div", { staticClass: "popin-container" }, [
        _c(
          "div",
          {
            staticClass: "popin-closure",
            on: { click: _vm.popin_reservationClosed },
          },
          [_c("div", { staticClass: "arrow" })]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "popin-closure-responsive",
            on: { click: _vm.popin_reservationClosed },
          },
          [_c("div", { staticClass: "arrow" }, [_vm._v("X")])]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "popin" }, [
          _c(
            "div",
            { class: { "popin-content": true, loaded: _vm.isPopinLoaded } },
            [
              _vm.isPopinLoaded
                ? [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(
                        "Réservation pour " +
                          _vm._s(_vm.scenarioInformations[_vm.currentScenario])
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.currentScenario == "nestor-bomb-simulator"
                      ? _c("span", { staticClass: "title-details" }, [
                          _vm._v(
                            "Cette réservation donne droit à 4 parties de 15 minutes de NESTOR"
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentPopinName == "choix-episode"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "popin-content-container choix-episode",
                          },
                          [
                            _c("span", { staticClass: "recap-confirmation" }, [
                              _vm._v(
                                "\n                            Cette aventure comporte deux épisodes de 60 minutes !\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._m(0),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-episodes" }, [
                              _c("div", { staticClass: "lq-col-2" }, [
                                _c("div", [
                                  _c(
                                    "button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.choixEpisode_buttonClicked(
                                            "single",
                                            1
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Épisode 1 seul")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Durée : 60 minutes")]),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.choixEpisode_buttonClicked(
                                            "single",
                                            2
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Épisode 2 seul")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Durée : 60 minutes")]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("div", [
                                  _c(
                                    "button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.choixEpisode_buttonClicked(
                                            "full"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        Épisode 1 + épisode 2\n                                        "
                                      ),
                                      _c("br"),
                                      _c("span", [
                                        _vm._v(
                                          "Profitez de l'aventure complète en totale immersion !"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Durée : 120 minutes")]),
                                ]),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentPopinName == "confirmation-episode"
                      ? _c(
                          "div",
                          { class: _vm.confirmationEpisode_bindClass() },
                          [
                            _vm.format_episode == "single" &&
                            _vm.numero_episode == 2
                              ? _c(
                                  "span",
                                  { staticClass: "recap-confirmation" },
                                  [
                                    _vm._v(
                                      "\n                            Vous avez choisi de réserver l'épisode 2 seul\n                        "
                                    ),
                                  ]
                                )
                              : _vm.format_episode == "full"
                              ? _c(
                                  "span",
                                  { staticClass: "recap-confirmation" },
                                  [
                                    _vm._v(
                                      "\n                            Vous avez choisi de réserver l'aventure complète (épisode 1 + 2)\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.should_requestWarning1confirmation
                              ? _c(
                                  "div",
                                  { staticClass: "form-infos with-warning" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "Pour profiter pleinement de cette aventure, il est nécessaire d'avoir déjà joué l'épisode 1 !"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "checkbox-container",
                                        attrs: {
                                          for: "form_episode2warning1Checked",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                Je confirme vouloir réserver l'épisode 2"
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "mandatory" },
                                          [_vm._v("*")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.formReservationInfos_episode2warning1Checked,
                                              expression:
                                                "formReservationInfos_episode2warning1Checked",
                                            },
                                          ],
                                          attrs: {
                                            type: "checkbox",
                                            id: "form_episode2warning1Checked",
                                            name: "form_episode2warning1Checked",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.formReservationInfos_episode2warning1Checked
                                            )
                                              ? _vm._i(
                                                  _vm.formReservationInfos_episode2warning1Checked,
                                                  null
                                                ) > -1
                                              : _vm.formReservationInfos_episode2warning1Checked,
                                          },
                                          on: {
                                            input:
                                              _vm.confirmationEpisodeConfirmButton_bindClass,
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.formReservationInfos_episode2warning1Checked,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.formReservationInfos_episode2warning1Checked =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.formReservationInfos_episode2warning1Checked =
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                }
                                              } else {
                                                _vm.formReservationInfos_episode2warning1Checked =
                                                  $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "checkmark",
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.should_requestWarning2confirmation
                              ? _c(
                                  "div",
                                  { staticClass: "form-infos with-warning" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                                Durant cette aventure, vous serez amenés à crapahuter et arpenter des espaces étroits dans lesquels \n                                il faut s'accroupir. Par conséquent, préférez une tenue dans laquelle vous êtes à l'aise et libre de vos mouvements.\n                            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "checkbox-container",
                                        attrs: {
                                          for: "form_episode2warning2Checked",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                Je confirme avoir pris connaissance des recommandations ci-dessus"
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "mandatory" },
                                          [_vm._v("*")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.formReservationInfos_episode2warning2Checked,
                                              expression:
                                                "formReservationInfos_episode2warning2Checked",
                                            },
                                          ],
                                          attrs: {
                                            type: "checkbox",
                                            id: "form_episode2warning2Checked",
                                            name: "form_episode2warning2Checked",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.formReservationInfos_episode2warning2Checked
                                            )
                                              ? _vm._i(
                                                  _vm.formReservationInfos_episode2warning2Checked,
                                                  null
                                                ) > -1
                                              : _vm.formReservationInfos_episode2warning2Checked,
                                          },
                                          on: {
                                            input:
                                              _vm.confirmationEpisodeConfirmButton_bindClass,
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.formReservationInfos_episode2warning2Checked,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.formReservationInfos_episode2warning2Checked =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.formReservationInfos_episode2warning2Checked =
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                }
                                              } else {
                                                _vm.formReservationInfos_episode2warning2Checked =
                                                  $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "checkmark",
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-confirmation-episode" },
                              [
                                _c("div", { staticClass: "lq-col-2" }, [
                                  _c("div", [
                                    _c(
                                      "button",
                                      {
                                        class:
                                          _vm.confirmationEpisodeConfirmButton_bindClass(),
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmerEpisode_buttonClicked(
                                              true
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Continuer")]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "button",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmerEpisode_buttonClicked(
                                              false
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("J'ai changé d'avis !")]
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentPopinName == "reservation-creneau"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "popin-content-container reservation-creneau",
                          },
                          [
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "column left" },
                                [
                                  _c("Calendrier", {
                                    ref: "reservationCalendrier",
                                    attrs: {
                                      view_isAdmin: _vm.view_paymentDelayed,
                                      view_scenarioSlug: _vm.currentScenario,
                                    },
                                    on: {
                                      calendrier_daySelected:
                                        _vm.calendrier_daySelected,
                                      calendrier_dayUnselected:
                                        _vm.calendrier_dayUnselected,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "column right" }, [
                                _c(
                                  "div",
                                  { attrs: { id: "creneaux" } },
                                  [
                                    _vm.creneaux_jour
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "liste-creneaux" },
                                            [
                                              _c("span", [
                                                _vm._v("Choisissez un horaire"),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                _vm._l(
                                                  _vm.creneaux_keys,
                                                  function (creneau_key) {
                                                    return _c(
                                                      "span",
                                                      {
                                                        staticClass: "creneau",
                                                        class:
                                                          _vm.choixCreneau_bindClass(
                                                            creneau_key
                                                          ),
                                                        attrs: {
                                                          "data-creneau":
                                                            creneau_key,
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.choixCreneau_click,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                        " +
                                                            _vm._s(
                                                              _vm.creneaux_jour[
                                                                creneau_key
                                                              ].label
                                                            ) +
                                                            "\n                                                        "
                                                        ),
                                                        _vm.creneauRoom_getAvailableType(
                                                          creneau_key
                                                        ) ==
                                                          "available_phone" &&
                                                        !_vm.view_paymentDelayed
                                                          ? [
                                                              _c("span", [
                                                                _vm._v(" ☎"),
                                                              ]),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.creneauxRoom_getAvailableType(
                                            _vm.creneaux_keys
                                          ) == "available_phone"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "wordings-creneaux",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "☎ vérifiez la disponibilité au 07 82 42 47 16"
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : _c(
                                          "div",
                                          { staticClass: "creneaux-error" },
                                          [_vm._m(1)]
                                        ),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("div", { attrs: { id: "compositions" } }, [
                                  _vm.currentCreneau
                                    ? _c(
                                        "div",
                                        { staticClass: "liste-compositions" },
                                        [
                                          _vm.creneauRoom_getAvailableType(
                                            _vm.currentCreneau
                                          ) == "available"
                                            ? [
                                                _c("span", [
                                                  _vm._v(
                                                    "Choisissez le nombre de personnes"
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "composition",
                                                      class:
                                                        _vm.choixComposition_bindClass(
                                                          2
                                                        ),
                                                      attrs: {
                                                        "data-composition": "2",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.choixComposition_click,
                                                      },
                                                    },
                                                    [_vm._v("2")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "composition",
                                                      class:
                                                        _vm.choixComposition_bindClass(
                                                          3
                                                        ),
                                                      attrs: {
                                                        "data-composition": "3",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.choixComposition_click,
                                                      },
                                                    },
                                                    [_vm._v("3")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "composition",
                                                      class:
                                                        _vm.choixComposition_bindClass(
                                                          4
                                                        ),
                                                      attrs: {
                                                        "data-composition": "4",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.choixComposition_click,
                                                      },
                                                    },
                                                    [_vm._v("4")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "composition",
                                                      class:
                                                        _vm.choixComposition_bindClass(
                                                          5
                                                        ),
                                                      attrs: {
                                                        "data-composition": "5",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.choixComposition_click,
                                                      },
                                                    },
                                                    [_vm._v("5")]
                                                  ),
                                                ]),
                                              ]
                                            : [
                                                _c("span", [
                                                  _vm._v(
                                                    "Une envie de dernière minute ? Appelez-nous au 07 82 42 47 16 !"
                                                  ),
                                                ]),
                                              ],
                                        ],
                                        2
                                      )
                                    : _vm.creneaux_jour
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "compositions-error",
                                          class: {
                                            available_phone:
                                              _vm.creneauxRoom_getAvailableType(
                                                _vm.creneaux_keys
                                              ) == "available_phone",
                                          },
                                        },
                                        [_vm._m(2)]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _vm.currentCreneau && _vm.currentComposition
                                  ? _c(
                                      "div",
                                      { attrs: { id: "confirmation" } },
                                      [
                                        _c(
                                          "button",
                                          {
                                            on: {
                                              click: _vm.reserver_buttonClicked,
                                            },
                                          },
                                          [_vm._v("Réserver")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "Le " +
                                              _vm._s(_vm.calendarDay) +
                                              " " +
                                              _vm._s(_vm.calendarLabel) +
                                              " à " +
                                              _vm._s(
                                                _vm.creneaux_jour[
                                                  _vm.currentCreneau
                                                ].label
                                              ) +
                                              " " +
                                              _vm._s(_vm.currentComposition) +
                                              " joueurs"
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                            _vm._v(" "),
                            !_vm.currentCreneau || !_vm.currentComposition
                              ? _c("div", { staticClass: "moyens-paiement" }, [
                                  _c("img", {
                                    attrs: {
                                      src: "/public/assets/images/icons_reservation_moyens_paiement.png",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _vm._m(4),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._m(5),
                          ]
                        )
                      : _vm.currentPopinName == "choix-mode"
                      ? _c(
                          "div",
                          { staticClass: "popin-content-container choix-mode" },
                          [
                            _c("span", { staticClass: "recap-confirmation" }, [
                              _vm._v(
                                "\n                            Choisissez un niveau de jeu\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-modes" }, [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.choixGameMode_click(
                                        "decouverte"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "icon decouverte" }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Classique")]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.choixGameMode_click(
                                        "intermediaire"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass: "icon intermediaire",
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Challenge")]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.choixGameMode_click("confirme")
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "icon confirme" }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Expert")]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._m(6),
                          ]
                        )
                      : _vm.currentPopinName ==
                        "check-creneau-reservation-in-progress"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "popin-content-container check-creneau-reservation-in-progress",
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Nous vérifions la disponibilité du créneau sélectionné..."
                              ),
                            ]),
                          ]
                        )
                      : _vm.currentPopinName ==
                        "check-creneau-reservation-in-progress-error"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "popin-content-container check-creneau-reservation-in-progress-error",
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Désolé ! Ce créneau n'est plus disponible !"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("a", { on: { click: _vm.changer_onClick } }, [
                                _vm._v("Choisir un autre créneau"),
                              ]),
                            ]),
                          ]
                        )
                      : _vm.currentPopinName == "reservation-infos"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "popin-content-container reservation-infos",
                          },
                          [
                            _c("span", { staticClass: "recap-confirmation" }, [
                              _vm._v(
                                "\n                            Réservation pour " +
                                  _vm._s(_vm.currentComposition) +
                                  " personnes le " +
                                  _vm._s(_vm.calendarDay) +
                                  " " +
                                  _vm._s(_vm.calendarLabel) +
                                  " à " +
                                  _vm._s(
                                    _vm.creneaux_jour[_vm.currentCreneau].label
                                  ) +
                                  "\n                            "
                              ),
                              _c("a", { on: { click: _vm.changer_onClick } }, [
                                _vm._v("Changer"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "rappel-mode-de-jeu" },
                              [
                                _vm.currentGameMode == "confirme"
                                  ? [_vm._v("Vous avez choisi le mode Expert")]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentGameMode == "intermediaire"
                                  ? [
                                      _vm._v(
                                        "Vous avez choisi le mode Challenge"
                                      ),
                                    ]
                                  : _vm.currentGameMode == "decouverte"
                                  ? [
                                      _vm._v(
                                        "Vous avez choisi le mode Classique"
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-infos" }, [
                              _c("div", { staticClass: "input-group" }, [
                                _c("div", { staticClass: "input-left" }, [
                                  _vm._m(7),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.formReservationInfos_teamName,
                                        expression:
                                          "formReservationInfos_teamName",
                                      },
                                    ],
                                    class: _vm.formReservationInfos_bindClass(
                                      _vm.formReservationInfos_teamName
                                    ),
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.formReservationInfos_teamName,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.formReservationInfos_teamName =
                                          $event.target.value
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input-right" }, [
                                  _c("span", [_vm._v("Raison sociale")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.formReservationInfos_businessName,
                                        expression:
                                          "formReservationInfos_businessName",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    domProps: {
                                      value:
                                        _vm.formReservationInfos_businessName,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.formReservationInfos_businessName =
                                          $event.target.value
                                      },
                                    },
                                  }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group" }, [
                                _c("div", { staticClass: "input-left" }, [
                                  _vm._m(8),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.formReservationInfos_lastName,
                                        expression:
                                          "formReservationInfos_lastName",
                                      },
                                    ],
                                    class: _vm.formReservationInfos_bindClass(
                                      _vm.formReservationInfos_lastName
                                    ),
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.formReservationInfos_lastName,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.formReservationInfos_lastName =
                                          $event.target.value
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input-right" }, [
                                  _vm._m(9),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.formReservationInfos_firstName,
                                        expression:
                                          "formReservationInfos_firstName",
                                      },
                                    ],
                                    class: _vm.formReservationInfos_bindClass(
                                      _vm.formReservationInfos_firstName
                                    ),
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.formReservationInfos_firstName,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.formReservationInfos_firstName =
                                          $event.target.value
                                      },
                                    },
                                  }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group" }, [
                                _c("div", { staticClass: "input-left" }, [
                                  _c("span", [_vm._v("Adresse")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.formReservationInfos_address,
                                        expression:
                                          "formReservationInfos_address",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.formReservationInfos_address,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.formReservationInfos_address =
                                          $event.target.value
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input-right" }, [
                                  _c("span", [_vm._v("Code postal")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.formReservationInfos_zipCode,
                                        expression:
                                          "formReservationInfos_zipCode",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.formReservationInfos_zipCode,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.formReservationInfos_zipCode =
                                          $event.target.value
                                      },
                                    },
                                  }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group" }, [
                                _c("div", { staticClass: "input-left" }, [
                                  _c("span", [_vm._v("Ville")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.formReservationInfos_city,
                                        expression: "formReservationInfos_city",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.formReservationInfos_city,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.formReservationInfos_city =
                                          $event.target.value
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input-right" }, [
                                  _vm._m(10),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.formReservationInfos_phoneNumber,
                                        expression:
                                          "formReservationInfos_phoneNumber",
                                      },
                                    ],
                                    class: _vm.formReservationInfos_bindClass(
                                      _vm.formReservationInfos_phoneNumber
                                    ),
                                    attrs: { type: "text" },
                                    domProps: {
                                      value:
                                        _vm.formReservationInfos_phoneNumber,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.formReservationInfos_phoneNumber =
                                          $event.target.value
                                      },
                                    },
                                  }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group" }, [
                                _c("div", { staticClass: "input-left" }, [
                                  _vm._m(11),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.formReservationInfos_email,
                                        expression:
                                          "formReservationInfos_email",
                                      },
                                    ],
                                    class: _vm.formReservationInfos_bindClass(
                                      _vm.formReservationInfos_email
                                    ),
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.formReservationInfos_email,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.formReservationInfos_email =
                                          $event.target.value
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _vm._m(12),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group" }, [
                                _c("div", { staticClass: "input-full" }, [
                                  _vm._m(13),
                                  _vm._v(" "),
                                  _vm._m(14),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.formReservationInfos_giftCardOrVoucherCode,
                                        expression:
                                          "formReservationInfos_giftCardOrVoucherCode",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    domProps: {
                                      value:
                                        _vm.formReservationInfos_giftCardOrVoucherCode,
                                    },
                                    on: {
                                      blur: _vm.bonCadeauOuCodePromo_check,
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.formReservationInfos_giftCardOrVoucherCode =
                                          $event.target.value
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.bonCadeauOuCodePromoProcess_amount > 0
                                    ? _c("div", {
                                        staticClass:
                                          "gift-card-or-voucher-code_checkmark",
                                      })
                                    : _vm._e(),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm._m(15),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-self" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "checkbox-container",
                                    attrs: { for: "form_CGVChecked" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    J'ai lu et j'accepte sans réserve les termes des C.G.V."
                                    ),
                                    _c("span", { staticClass: "mandatory" }, [
                                      _vm._v("*"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.formReservationInfos_areTermsAgreed,
                                          expression:
                                            "formReservationInfos_areTermsAgreed",
                                        },
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        id: "form_CGVChecked",
                                        name: "form_CGVChecked",
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.formReservationInfos_areTermsAgreed
                                        )
                                          ? _vm._i(
                                              _vm.formReservationInfos_areTermsAgreed,
                                              null
                                            ) > -1
                                          : _vm.formReservationInfos_areTermsAgreed,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a =
                                              _vm.formReservationInfos_areTermsAgreed,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.formReservationInfos_areTermsAgreed =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.formReservationInfos_areTermsAgreed =
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.formReservationInfos_areTermsAgreed =
                                              $$c
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "checkmark" }),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-submit" }, [
                                _c("span", { staticClass: "form-error" }, [
                                  _vm._v(
                                    _vm._s(_vm.formReservationInfos_error)
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.tarifs
                                  ? _c(
                                      "div",
                                      {
                                        class: {
                                          acompte:
                                            _vm.getTarif() -
                                              _vm.bonCadeauOuCodePromoProcess_amount >
                                            _vm.getTarif() /
                                              _vm.currentComposition,
                                        },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            attrs: {
                                              disabled:
                                                !_vm.tarifs &&
                                                _vm.bonCadeauOuCodePromoProcess_isChecking,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.payer_buttonClicked(
                                                  true
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        Payer (" +
                                                _vm._s(
                                                  _vm.getTarif() -
                                                    _vm.bonCadeauOuCodePromoProcess_amount
                                                ) +
                                                "€ TTC)\n                                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.getTarif() -
                                          _vm.bonCadeauOuCodePromoProcess_amount >
                                        _vm.getTarif() / _vm.currentComposition
                                          ? _c(
                                              "button",
                                              {
                                                attrs: {
                                                  disabled:
                                                    !_vm.tarifs &&
                                                    _vm.bonCadeauOuCodePromoProcess_isChecking,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.payer_buttonClicked(
                                                      false
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        Payer un acompte (" +
                                                    _vm._s(
                                                      _vm.getTarif() /
                                                        _vm.currentComposition
                                                    ) +
                                                    "€ TTC)\n                                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                          ]
                        )
                      : _vm.currentPopinName ==
                        "refresh-creneau-reservation-in-progress"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "popin-content-container refresh-creneau-reservation-in-progress",
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Nous vérifions la disponibilité du créneau sélectionné..."
                              ),
                            ]),
                          ]
                        )
                      : _vm.currentPopinName ==
                        "refresh-creneau-reservation-in-progress-error"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "popin-content-container refresh-creneau-reservation-in-progress-error",
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Désolé ! Ce créneau n'est plus disponible !"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("a", { on: { click: _vm.changer_onClick } }, [
                                _vm._v("Choisir un autre créneau"),
                              ]),
                            ]),
                          ]
                        )
                      : _vm.currentPopinName == "reservation-process"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "popin-content-container reservation-process",
                          },
                          [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.reservationProcess_message
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _vm.moneticoFields
                              ? _c(
                                  "form",
                                  {
                                    ref: "moneticoForm",
                                    attrs: {
                                      method: "post",
                                      target: "_top",
                                      action:
                                        "https://p.monetico-services.com/paiement.cgi",
                                    },
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "hidden",
                                        name: "ThreeDSecureChallenge",
                                      },
                                      domProps: {
                                        value:
                                          _vm.moneticoFields
                                            .ThreeDSecureChallenge,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: {
                                        type: "hidden",
                                        name: "version",
                                      },
                                      domProps: {
                                        value: _vm.moneticoFields.version,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: { type: "hidden", name: "TPE" },
                                      domProps: {
                                        value: _vm.moneticoFields.TPE,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: { type: "hidden", name: "date" },
                                      domProps: {
                                        value: _vm.moneticoFields.date,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: {
                                        type: "hidden",
                                        name: "montant",
                                      },
                                      domProps: {
                                        value: _vm.moneticoFields.montant,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: {
                                        type: "hidden",
                                        name: "reference",
                                      },
                                      domProps: {
                                        value: _vm.moneticoFields.reference,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: { type: "hidden", name: "MAC" },
                                      domProps: {
                                        value: _vm.moneticoFields.MAC,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: {
                                        type: "hidden",
                                        name: "url_retour",
                                      },
                                      domProps: {
                                        value: _vm.moneticoFields.url_retour,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: {
                                        type: "hidden",
                                        name: "url_retour_ok",
                                      },
                                      domProps: {
                                        value: _vm.moneticoFields.url_retour_ok,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: {
                                        type: "hidden",
                                        name: "url_retour_err",
                                      },
                                      domProps: {
                                        value:
                                          _vm.moneticoFields.url_retour_err,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: { type: "hidden", name: "lgue" },
                                      domProps: {
                                        value: _vm.moneticoFields.lgue,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: {
                                        type: "hidden",
                                        name: "societe",
                                      },
                                      domProps: {
                                        value: _vm.moneticoFields.societe,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: {
                                        type: "hidden",
                                        name: "contexte_commande",
                                      },
                                      domProps: {
                                        value:
                                          _vm.moneticoFields.contexte_commande,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: { type: "hidden", name: "mail" },
                                      domProps: {
                                        value: _vm.moneticoFields.mail,
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]
                : [_c("Loader")],
            ],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v(
        "\n                            Vous pouvez jouer chaque épisode l'un après l'autre de façon indépendante,\n                            "
      ),
      _c("br"),
      _vm._v(
        "ou jouer les deux épisodes enchaînés en une grande aventure immersive !\n                        "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Veuillez sélectionner une journée"),
      _c("br"),
      _vm._v("dans le calendrier sur la gauche"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Veuillez sélectionner un créneau parmi "),
      _c("br"),
      _vm._v("ceux disponibles ci-dessus"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("span", [_vm._v("Chèques vacances, espèces")]),
      _vm._v(" : un acompte CB vous sera demandé en fin d'inscription"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("span", [_vm._v("Pass Culture")]),
      _vm._v(
        " : inscription par téléphone au 07 82 42 47 16 muni de votre code"
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "legende" }, [
        _c("span", { staticClass: "not_available" }),
        _vm._v(" "),
        _c("span", [_vm._v("Non disponible")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legende" }, [
        _c("span", { staticClass: "available" }),
        _vm._v(" "),
        _c("span", [_vm._v("Disponible")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legende" }, [
        _c("span", { staticClass: "last_chance" }),
        _vm._v(" "),
        _c("span", [_vm._v("Dernières places")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legende" }, [
        _c("span", { staticClass: "full" }),
        _vm._v(" "),
        _c("span", [_vm._v("Complet")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legende" }, [
        _c("span", { staticClass: "active" }),
        _vm._v(" "),
        _c("span", [_vm._v("Sélection")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-modes-tips" }, [
      _c("div", [
        _c("span", [_vm._v("Classique - Difficulté : 6/10")]),
        _vm._v(
          "\n                                Vous devrez faire preuve de logique, d'observation et être bien \n                                organisés pour vous en sortir... Pas fastoche ! Ce mode est vivement conseillé si vous \n                                débutez ou êtes en présence de plus jeunes (8 ans et +).\n                            "
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("span", [_vm._v("Challenge - Difficulté : 8/10")]),
        _vm._v(
          "\n                                Vous êtes un habitué des Escape Game ? Ce mode de jeu pourrait vous \n                                challenger avec moins d'indices et des énigmes plus corsées.\n                            "
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("span", [_vm._v("Expert - Difficulté : 10/10")]),
        _vm._v(
          "\n                                Vous sortez toujours en moins de 50 minutes des salles d'Escape Game ? \n                                Voici un mode de jeu concocté spécialement pour ceux qui recherchent un véritable défi !\n                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Nom de l'équipe"),
      _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Nom"),
      _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Prénom"),
      _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Téléphone"),
      _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Adresse email"),
      _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-right" }, [
      _c("span", [
        _vm._v("Langue"),
        _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
      ]),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "text", disabled: "disabled", value: "Français" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "normal-block mw1120" }, [
      _vm._v(
        "\n                                        Entrez ici le code d'un bon cadeau ou un code promo\n                                        "
      ),
      _c("span", { staticClass: "infos" }, [
        _vm._v(
          "(En cours de validité, à présenter impérativement à votre arrivée)"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "responsive-block mw1120" }, [
      _vm._v(
        "\n                                        Code promo\n                                        "
      ),
      _c("span", { staticClass: "infos" }, [
        _vm._v(
          "\n                                            En cours de validité *\n                                            "
        ),
        _c("br"),
        _vm._v(
          "À présenter impérativement à votre arrivée **\n                                        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "information responsive-block mw1120" }, [
      _vm._v(
        "\n                                En cas d'utilisation d'un code promo, ce dernier doit être valide\n                                "
      ),
      _c("br"),
      _vm._v(
        " et devra être présenté impérativement à votre arrivée\n                            "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }